// extracted by mini-css-extract-plugin
export default {"block":"XZ0mx3wl","head":"Bhmd1HFW","label":"i0h1R9Ep","origin":"Xl7Lv2Rn","editBtn":"lqBYe7xv","text":"jKwwypJa","actions":"KqpPN3Yy","addBtn":"LvuByKId"};